export const gateway = "https://gbiconsultants-bms-api.link.wawanesalife.com";
export const LoginUrlParameter = "https://stable-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=oa9gblubqeplau3d23e74qpnd&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fgbiconsultants-bms.link.wawanesalife.com%2Fredirect";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "oa9gblubqeplau3d23e74qpnd";
export const BrokerPoolDomainParameter = "stable-brokers";
export const BrokerPoolParameter = "ca-central-1_smmgFhHsy";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://gbiconsultants.link.wawanesalife.com";

//updated on Fri May 08 2026 14:33:48 GMT-0500 (Central Daylight Time)
